import { ApiCaller } from '@graphit/callers'

export async function logout() {
	await ApiCaller.logout()
	window.location.reload()
}

export async function isAuth() {
	const status = await ApiCaller.getUserStatus()

	return status.authenticated
}
